// Human-readable labels for user roles, used in dashboard welcome messages.
const ROLE_LABELS = {
  super_admin: 'Super Admin',
  university_admin: 'University Admin',
  coe: 'Controller of Examinations',
  college_admin: 'College Admin',
  hod: 'Head of Department',
  moderator: 'Moderator',
  subject_matter_expert: 'Subject Matter Expert',
  examiner: 'Examiner',
  coordinator: 'Coordinator',
};

export const formatRole = (role) => {
  if (!role) return '';
  return ROLE_LABELS[role] || role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export default formatRole;
